export const PWG_SPORTS_PRODUCT = Object.freeze({
  productKey: "pwg",
  publicName: "PWG Sports",
  entitlement: "PWG",
  public: true,
  trial: false,
  offers: Object.freeze({
    monthly: Object.freeze({ term: "monthly", amountCents: 6999, displayAmount: "$69.99", intervalLabel: "month" }),
    threeMonth: Object.freeze({ term: "three_month", amountCents: 14999, displayAmount: "$149.99", intervalLabel: "3 months" }),
  }),
  threeMonthSavings: Object.freeze({ amountCents: 5998, displayAmount: "$59.98", effectiveMonthly: "$49.99" }),
});

export const PUBLIC_PRODUCTS = Object.freeze([PWG_SPORTS_PRODUCT]);
